document.addEventListener('DOMContentLoaded', () => {
  const employeesFilter = new EmployeesFilter()
  employeesFilter.init()
})

class EmployeesFilter {
  constructor () {
    this.EMPLOYEE_SECTIONS = document.querySelectorAll('.mt-employees')
    this.EMPLOYEE_SECTION = ''
    this.CATEGORY = 0
    this.SEARCH = ''
  }

  init () {
    if (this.EMPLOYEE_SECTIONS.length > 0) {
      this.EMPLOYEE_SECTIONS.forEach(EMPLOYEE_SECTION => {
        this.EMPLOYEE_SECTION = EMPLOYEE_SECTION
        this.addEventListeners()
      })
    }
  }

  addEventListeners() {
    this.FILTER_BUTTONS = this.EMPLOYEE_SECTION.querySelectorAll('.mt-employees__filter button')
    this.FILTER_SELECT = this.EMPLOYEE_SECTION.querySelector('.mt-employees__dropdown')
    this.FILTER_SEARCH = this.EMPLOYEE_SECTION.querySelector('.mt-employees__search')
    this.EMPLOYEES_GRID = this.EMPLOYEE_SECTION.querySelector('.mt-employees__grid')

    let searchTimer = null;

    if (this.FILTER_BUTTONS.length > 0) {
      for (let index = 0; index < this.FILTER_BUTTONS.length; index++) {
        const button = this.FILTER_BUTTONS[index]

        button.addEventListener('click', () => {
          this.CATEGORY = button.getAttribute('data-term-id')

          this.changeActiveCategory()
          this.getEmployees()
        })
      }
    }
    if(this.FILTER_SELECT){
      this.FILTER_SELECT.addEventListener('change', () => {
        this.CATEGORY = this.FILTER_SELECT.value

        this.changeActiveCategory()
        this.getEmployees()
      })
    }
    if(this.FILTER_SEARCH){
      this.FILTER_SEARCH.addEventListener('input', (e) => {
        e.preventDefault();

        if(searchTimer == null){
          searchTimer = setTimeout(() => {
            this.searchEmployees(this.FILTER_SEARCH);
          }, 500);
        }
        else{
          clearTimeout(searchTimer);
          searchTimer = setTimeout(() => {
            this.searchEmployees(this.FILTER_SEARCH);
          }, 500);
        }
      })
    }
  }

  searchEmployees(SEARCH_INPUT) {
    this.SEARCH = SEARCH_INPUT.value
    this.getEmployees()
  }

  changeActiveCategory(){
    if(this.EMPLOYEE_SECTION.querySelector('.mt-employees__filter button.active')){
      this.EMPLOYEE_SECTION.querySelector('.mt-employees__filter button.active').classList.remove('active')
      this.EMPLOYEE_SECTION.querySelector('.mt-employees__filter button[data-term-id="'+this.CATEGORY+'"]').classList.add('active')
    }
    this.FILTER_SELECT.value = this.CATEGORY
  }

  getEmployees(){
    this.EMPLOYEE_SECTION.querySelector('.mt-loader').classList.add('show')
    const data = {
      action: 'filter_employees',
      termId: this.CATEGORY,
      search: this.SEARCH
    }

    jQuery.post(mt_all_employees.ajax_url, data, (response) => {
      if (response !== 0) {
        this.EMPLOYEES_GRID.innerHTML = response.markup
        this.EMPLOYEE_SECTION.querySelector('.mt-loader').classList.remove('show')
      }
    })
  }
}
